import { MessageCircle } from "lucide-react";

export const WHATSAPP_URL = `https://wa.me/917479913855?text=${encodeURIComponent("Hi RentMyDate, I need help with")}`;

export const WhatsAppButton = ({ label = "Chat on WhatsApp", className = "", testId = "whatsapp-btn" }) => (
  <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid={testId}
     className={`inline-flex items-center gap-2 rounded-full bg-[#25D366] px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-transform hover:-translate-y-0.5 hover:bg-[#1ebe5b] ${className}`}>
    <MessageCircle size={18} />{label}
  </a>
);
